import { render, staticRenderFns } from "./WidgetUac.vue?vue&type=template&id=5debb459&scoped=true"
import script from "./WidgetUac.vue?vue&type=script&lang=js"
export * from "./WidgetUac.vue?vue&type=script&lang=js"
import style0 from "./WidgetUac.vue?vue&type=style&index=0&id=5debb459&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5debb459",
  null
  
)

export default component.exports